// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_cj-3";
export var contentContainer = "_cj-0";
export var editorContainer = "_cj-1";
export var quillInputForm = "_cj-2";
export var zoneDivider = "_cj-4";